export function toFixedNoRounding(num: number, decimals: number): string {
  // Multiply to shift the decimal point, then use Math.trunc to chop off excess without rounding
  const factor = Math.pow(10, decimals);
  const truncated = Math.trunc(num * factor) / factor;
  // Use toFixed to ensure the decimal places are formatted correctly
  return truncated.toFixed(decimals);
}
